export default __webpack_public_path__ + "static/media/Elle_Tiffany_2021_04_210858.2bfca913.jpg";